// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__Lv1ZP","waveAnimation":"Heading_waveAnimation__pFCp0","marquee":"Heading_marquee__VPRfd"};